<template>
    <!-- display buttons for save for later here -->
    <button @click.prevent="saveItemFxn(itemId)">
        <i class="far fa-save"></i> Save for Later
    </button>
</template>

<script>
export default {
    name: 'SaveForLater',
    props: {
        itemId: {
            type: String,
            required: true
        },
    },
    data() {
        return {
            itemSavedStatus: false,
        }
    },
    methods: {
        saveItemFxn(theItemId) {
            // check if user already have a save-for-later items storage on local-storage
            let localStorageSFLItemIds = JSON.parse(localStorage.getItem('ani_items_sfl')) 
            if(localStorageSFLItemIds) {
                localStorageSFLItemIds.push(theItemId)
                localStorage.setItem('ani_items_sfl', JSON.stringify(localStorageSFLItemIds))
            } 
            // create a new save-for-later storage on local-storage
            else {
                let itemsIdSaveArr = [theItemId]
                localStorage.setItem('ani_items_sfl', JSON.stringify(itemsIdSaveArr))
            }

            // check and update items saved status
            this.itemSavedChecker(theItemId)
        },
        itemSavedChecker(theItemId) {
            this.$emit('emitItemSavedChecker', theItemId)
        }
    },
}
</script>
